export default "__VITE_ASSET__Domtp8tQ__"